import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ReactTooltip from 'react-tooltip'
import { Toggle } from '../Toggle'
import uniqid from 'uniqid'

import './ToggleWithLabelAndTooltip.scss'

export const ToggleWithLabelAndTooltip = ({
  label,
  isOn,
  isDisabled,
  tootipLabel,
  tooltipToggle,
  className,
  callback
}) => {
  // const [on, setOn] = useState(isOn)

  const { current: inputId } = useRef(uniqid())

  const classSwitcher = classNames('switcher', className, {
    c_on: isOn
  })

  // useEffect(() => {
  //   callback(isOn)
  // }, [isOn])

  useEffect(() => {
    ReactTooltip.rebuild()
    return () => {
      ReactTooltip.rebuild()
    }
  }, [tooltipToggle, tootipLabel])

  function handleChange (e) {
    if (!isDisabled) {
      callback(e.target.checked)
    }
  }

  return (
    <>
      <div className={classSwitcher}>
        {label && <label htmlFor={inputId}>{label}</label>}{' '}
        {tootipLabel && (
          <span data-tip={tootipLabel} className='info-tooltip' />
        )}
        <Toggle
          checked={isOn}
          disabled={isDisabled}
          onChange={handleChange}
          id={inputId}
        />
      </div>
      {tooltipToggle && isDisabled && (
        <div className='tooltip-switcher-box' data-tip={tooltipToggle} />
      )}
    </>
  )
}

// style='display: none; overflow: hidden;'

ToggleWithLabelAndTooltip.defaultProps = {
  // separator: '/',
}

ToggleWithLabelAndTooltip.propTypes = {
  label: PropTypes.string,
  tootipLabel: PropTypes.string,
  isOn: PropTypes.bool,
  className: PropTypes.string,
  callback: PropTypes.func,
  isDisabled: PropTypes.bool,
  tooltipToggle: PropTypes.string
}
